import { useEffect, useState } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import BookingDialog from "@/components/site/BookingDialog";
import AteliersHero from "@/components/ateliers/AteliersHero";
import AteliersProblem from "@/components/ateliers/AteliersProblem";
import WhatIsIt from "@/components/ateliers/WhatIsIt";
import WhyGroup from "@/components/ateliers/WhyGroup";
import HowItWorks from "@/components/ateliers/HowItWorks";
import Participation from "@/components/ateliers/Participation";
import Benefits from "@/components/ateliers/Benefits";
import DatesCTA from "@/components/ateliers/DatesCTA";
import Objections from "@/components/ateliers/Objections";
import AteliersFinalCTA from "@/components/ateliers/AteliersFinalCTA";
import WorkshopDialog from "@/components/ateliers/WorkshopDialog";
import NotifyDialog from "@/components/ateliers/NotifyDialog";
import { fetchWorkshops } from "@/lib/api";

export default function AteliersPage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [workshopDialogOpen, setWorkshopDialogOpen] = useState(false);
  const [notifyOpen, setNotifyOpen] = useState(false);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [workshops, setWorkshops] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    fetchWorkshops()
      .then(setWorkshops)
      .catch(() => setWorkshops([]));
  }, []);

  const openRegistration = (w = null) => {
    setSelectedWorkshop(w);
    setWorkshopDialogOpen(true);
  };

  const openNotify = () => setNotifyOpen(true);
  const scrollToDates = () => {
    document.getElementById("dates")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-[#FAF7F8] text-[#1E1E2A]" data-testid="ateliers-page">
      <Navbar onBookingClick={() => setBookingOpen(true)} />
      <main>
        <AteliersHero onSeeDates={scrollToDates} />
        <AteliersProblem />
        <WhatIsIt />
        <WhyGroup />
        <HowItWorks />
        <Participation onRegister={openRegistration} />
        <Benefits />
        <DatesCTA
          workshops={workshops}
          onRegister={openRegistration}
          onNotify={openNotify}
        />
        <Objections />
        <AteliersFinalCTA
          onRegister={() => openRegistration(null)}
          onNotify={openNotify}
        />
      </main>
      <Footer />

      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
      <WorkshopDialog
        open={workshopDialogOpen}
        onOpenChange={setWorkshopDialogOpen}
        workshops={workshops}
        preselected={selectedWorkshop}
      />
      <NotifyDialog open={notifyOpen} onOpenChange={setNotifyOpen} />
    </div>
  );
}
